import React, { useRef, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrollableDialog from '../common/ScrollableDialog';
import PrimaryActionButton from '../common/PrimaryActionButton';
import TeamMemberCompensationForm from '../employee-payments/TeamMemberCompensationForm';

const TeamMemberCompensationDialog = ({
  open,
  onClose,
  storeId,
  teamMemberId,
  teamMemberName,
  canEdit,
  onSaved,
}) => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleClose = () => {
    if (!isSaving) {
      onClose();
    }
  };

  const handleSave = async () => {
    const form = formRef.current;
    if (!form?.canSave) {
      return;
    }

    setIsSaving(true);
    try {
      const saved = await form.save();
      if (saved) {
        onClose();
      }
    } finally {
      setIsSaving(false);
    }
  };

  if (!teamMemberId) {
    return null;
  }

  return (
    <ScrollableDialog
      open={open}
      onClose={isSaving ? undefined : handleClose}
      maxWidth="sm"
      title={t('employeePayments.compensation.editTitle', { name: teamMemberName || t('employeePayments.payroll.unknownMember') })}
      subtitle={t('employeePayments.compensation.subtitle')}
      dividers
      showCloseButton
      titleSx={{ pb: 1, flexShrink: 0 }}
      actionsSx={{
        flexShrink: 0,
        justifyContent: 'space-between',
      }}
      actions={canEdit ? (
        <>
          <Button onClick={handleClose} disabled={isSaving} color="inherit">
            {t('common.cancel')}
          </Button>
          <PrimaryActionButton onClick={handleSave} disabled={isSaving}>
            {isSaving ? t('common.saving') : t('common.save')}
          </PrimaryActionButton>
        </>
      ) : (
        <Button onClick={handleClose} disabled={isSaving} color="inherit">
          {t('common.close')}
        </Button>
      )}
    >
      <TeamMemberCompensationForm
        ref={formRef}
        key={teamMemberId}
        storeId={storeId}
        teamMemberId={teamMemberId}
        canEdit={canEdit}
        onSaved={onSaved}
        showSaveButton={false}
      />
    </ScrollableDialog>
  );
};

export default TeamMemberCompensationDialog;
